<template>
  <div>
    <div
      v-for="(con, i) in messageList"
      :key="i"
      @contextmenu.prevent="handleRightClick(con)"
    >
      <!-- is Message From System -->

      <div
        v-if="con.userType == 'system'"
        class="px-2 mb-3 message_system_type"
        :id="`ref-msg-${con.id}`"
      >
        <div v-if="con.systemType == systemTypes.TicketUpdated">
          <div class="separator ticket">
            <span
              class="font-italic mr-1"
              @click="showFormTicket(con.ticketUrl)"
              >{{ con.message }}</span
            >
          </div>
        </div>

        <div v-else-if="con.adminName && con.adminName.trim() == ''">
          <div class="separator">
            <span class="font-italic mr-1">{{ con.message }}</span>
          </div>
        </div>
        <div v-else-if="con.systemType == systemTypes.AdminLeaveGroupMention">
          <div class="separator">
            <span class="admin-name mr-1">{{ con.adminName }}</span>
            <span class="font-italic">{{ con.message }}</span>
          </div>
        </div>
        <div v-else-if="con.systemType == systemTypes.AssignTo">
          <div class="separator">
            <span class="font-italic mr-1"
              >{{ con.message }}
              <span class="admin-name">{{ con.toAdminName }}</span> by</span
            >
            <span class="admin-name">{{ con.adminName }}</span>
          </div>
        </div>
        <div v-else-if="con.systemType == systemTypes.Unknown">
          <div class="separator">
            <span class="font-italic mr-1" @click="handleClickUnknownType(con)"
              >{{ con.message }}
              <span class="click-for-detail">{{ $t("clickForDetails") }}</span>
            </span>
          </div>
        </div>
        <div
          v-else-if="
            con.systemType == systemTypes.MoveToPending ||
              con.systemType == systemTypes.MoveToClose ||
              con.systemType == systemTypes.MoveToCase
          "
        >
          <div class="separator">
            <span class="font-italic mr-1">{{ con.message }}</span>
            <span
              v-if="con.adminName && con.adminName.length > 0"
              class="mx-1 font-italic"
              >by</span
            >
            <span class="admin-name">{{ con.adminName }}</span>
          </div>
        </div>
        <div
          v-else-if="con.topicId || (con.topicsIds && con.topicsIds.length > 0)"
        >
          <div class="separator">
            <span class="font-italic mr-1">{{ con.message }}</span>
            <span class="admin-name">{{ con.topicName }}</span>
            <span
              v-if="con.adminName && con.adminName.length > 0"
              class="mx-1 font-italic"
              >by</span
            >
            <span class="admin-name">{{ con.adminName }}</span>
          </div>
        </div>
        <div v-else-if="con.toAdminName && con.toAdminName.trim()">
          <div class="separator">
            <span class="font-italic mr-1">{{ con.message }}</span>
            <span v-if="con.toAdminName != con.adminName" class="admin-name">{{
              con.toAdminName
            }}</span>
            <span
              v-if="
                con.toAdminName != con.adminName &&
                  con.adminName &&
                  con.adminName.length > 0
              "
              class="mx-1 font-italic"
              >by</span
            >
            <span class="admin-name">{{ con.adminName }}</span>
          </div>
        </div>
        <div v-else class="separator">
          {{ con.message }}
          <span v-if="con.adminName && con.adminName.length > 0" class="mx-1"
            >by</span
          >
          <span class="admin-name">{{ con.adminName }}</span>
        </div>
        <div class="end-chat-time text-center">
          <b-spinner
            v-if="con.isWaitSend"
            label="sending..."
            class="sending-chat"
          ></b-spinner>
          <div
            v-else-if="con.isSendFail || con.isSendSuccess === false"
            class="send-fail justify-content-center"
            @click="handleReSendMessage(con)"
          >
            {{ $t("sendAgain") }}
            <font-awesome-icon icon="exclamation-circle" />
          </div>
          <ChatDateTime v-else :date="con.createdTime" />
        </div>
      </div>
      <!-- <div class="px-2 mb-3">
        <div class="">
          {{ con.message }}
        </div>
      </div> -->
      <!-- is Text From Me -->
      <!-- v-else-if="con.isAdmin || con.isDummy" -->
      <div
        v-if="con.userType == 'admin'"
        :class="[
          'd-flex align-items-end flex-column justify-content-end mb-4',
          con.userType
        ]"
      >
        <!-- <div v-if="con.isDummy" class="my-auto pr-2 pl-3">
          <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div> -->

        <div
          :id="`ref-msg-${con.id}`"
          :class="[
            'wrap_msg_cotainer_send',
            { 'w-100': !con.replyForm && con.messageType == 4 }
          ]"
        >
          <!-- reply -->
          <div
            v-if="con.replyForm"
            :class="[
              'reply_container',
              con.replyForm?.messageType == 4
                ? 'msg_cotainer_send_img'
                : con.replyForm?.isPrivateChat
                ? 'msg_cotainer_send_private'
                : 'msg_cotainer_send'
            ]"
            @click="goToMsgId(con.replyForm)"
          >
            <ChatBoxReplyProfile :msg="con.replyForm" />
            <div class="wrap_img_upload" v-if="con.replyForm?.messageType == 4">
              <div class="img_upload">
                <div
                  class="img_upload-display"
                  v-bind:style="{
                    backgroundImage: 'url(' + con.replyForm?.filePath + ')'
                  }"
                ></div>
              </div>
            </div>
            <span
              v-else
              class="text-nextline"
              v-html="con.replyForm?.message"
            ></span>
          </div>
          <!-- end reply -->

          <div
            :class="[
              con.messageType == 4
                ? 'msg_cotainer_send_img'
                : con.isPrivateChat
                ? 'msg_cotainer_send_private'
                : 'msg_cotainer_send'
            ]"
          >
            <span
              v-if="
                con.messageType == 1 ||
                  con.messageType == 98 ||
                  con.messageType == 21 ||
                  con.messageType == 16 ||
                  con.messageType == 22
              "
              class="text-nextline"
              v-html="con.message"
            ></span>
            <div class="wrap_img_upload" v-if="con.messageType == 4">
              <div class="img_upload" @click="openModalImage(con.filePath)">
                <div
                  class="img_upload-display"
                  v-bind:style="{
                    backgroundImage: 'url(' + con.filePath + ')'
                  }"
                ></div>
              </div>
            </div>
            <!-- Other Type -->
            <!-- messageType = 21 postback -->
            <div
              v-if="
                con.messageType != 1 &&
                  con.messageType != 4 &&
                  con.messageType != 21 &&
                  con.messageType != 16 &&
                  con.messageType != 22
              "
            >
              <ChatBoxWidget :con="con" />
            </div>
            <div v-if="con.messageType == messageTypes.Audio">
              <div v-if="con.messageType == messageTypes.Audio">
                <ChatAudioPlayer
                  :filePath="con.filePath"
                  :userType="con.userType"
                />
              </div>
            </div>

            <!-- con.messageResponse.content.responseType == 8 ? 'extent-width' : '' -->
            <!-- <div
              v-if="
                con.messageResponse.content.responseType == 6 ||
                  con.messageResponse.content.responseType == 2
              "
            >
              <div
                v-for="(item, i) in con.messageResponse.content.imageList"
                :key="i"
                class="img_upload"
              >
                <div
                  class="img_upload-display"
                  v-bind:style="{
                    backgroundImage: 'url(' + item.imageUrl + ')'
                  }"
                ></div>
              </div>
              <div
                v-if="con.messageResponse.content.responseType == 2"
                class="text-right"
              >
                <span
                  class="ml-auto bg-white text-dark p-2 mt-1 rounded text-black"
                  >{{ con.messageResponse.content.text }}
                </span>
              </div>
            </div> -->
            <!-- <ChatBoxWidget :con="con" v-else /> -->
          </div>
          <ChatBoxOptions
            :ref="`chatbox-option-${con.id}`"
            @reply="reply"
            @close="close"
          />
        </div>

        <span class="msg_time_send text-nowrap">
          <b-spinner
            v-if="con.isWaitSend"
            label="sending..."
            class="sending-chat"
          ></b-spinner>
          <div
            v-else-if="con.isSendFail || con.isSendSuccess === false"
            class="send-fail"
            @click="handleReSendMessage(con)"
          >
            {{ con.responseMessage + " " }} {{ $t("sendAgain") }}
            <font-awesome-icon icon="reply" />
          </div>
          <ChatDateTime v-else :date="con.createdTime" />
          <span v-if="con.adminName">
            (<span>{{ con.adminName }}</span
            >)
          </span>
          <font-awesome-icon v-if="con.isSendSuccess === true" icon="check" />
        </span>
      </div>
      <!-- is Text From Other -->
      <div
        v-else-if="con.userType == 'user'"
        :class="['d-flex justify-content-start mb-4 px-2', con.userType]"
      >
        <div class="img_cont_msg">
          <div
            v-if="otherInfo.imageUrl && otherInfo.imageUrl.trim()"
            class="rounded-circle user_img_msg"
          >
            <div
              class="rounded-circle user_img_display"
              v-bind:style="{
                backgroundImage: 'url(' + otherInfo.imageUrl + ')'
              }"
            ></div>
          </div>
          <font-awesome-icon
            v-else
            :icon="['fas', 'user']"
            class="rounded-circle user_img_msg p-1"
          />
        </div>
        <div
          :id="`ref-msg-${con.id}`"
          :class="[
            'wrap_msg_cotainer_send',
            { 'w-100': !con.replyForm && con.messageType == 4 }
          ]"
        >
          <!-- reply -->
          <div
            v-if="con.replyForm"
            :class="[
              'reply_container',
              con.replyForm?.messageType == 4 || con.replyForm?.messageType == 2
                ? 'msg_cotainer_img'
                : 'msg_cotainer'
            ]"
            @click="goToMsgId(con.replyForm)"
          >
            <ChatBoxReplyProfile :msg="con.replyForm" />
            <div class="wrap_img_upload" v-if="con.replyForm?.messageType == 4">
              <div class="img_upload">
                <div
                  class="img_upload-display"
                  v-bind:style="{
                    backgroundImage: 'url(' + con.replyForm?.filePath + ')'
                  }"
                ></div>
              </div>
            </div>
            <span
              v-else
              class="text-nextline"
              v-html="con.replyForm?.message"
            ></span>
          </div>
          <!-- end reply -->
          <div
            :class="[
              con.messageType == 4 ||
              con.messageType == 2 ||
              con.messageType == messageTypes.Audio
                ? 'msg_cotainer_img'
                : 'msg_cotainer'
            ]"
          >
            <span
              v-if="
                con.messageType == 1 ||
                  con.messageType == 98 ||
                  con.messageType == 21 ||
                  con.messageType == 16 ||
                  con.messageType == 22
              "
              class="text-nextline"
              v-html="con.message"
            ></span>
            <div
              v-if="con.messageType == 4"
              :class="!con.filePath.includes(',') && 'img_upload'"
            >
              <div v-if="con.filePath.includes(',')">
                <div class="multi-img">
                  <img
                    v-for="(img, index) in con.filePath.split(',')"
                    :key="index"
                    :src="img.trim()"
                    class="img_display"
                    @click="openModalImage(img)"
                  />
                </div>
              </div>
              <div
                v-else
                @click="openModalImage(con.filePath)"
                :class="[
                  'img_upload-display',
                  con.filePath.includes('stickershop') &&
                    'sticker_upload-display'
                ]"
                v-bind:style="{
                  backgroundImage: 'url(' + con.filePath + ')'
                }"
              ></div>
            </div>
            <!-- Other Type -->

            <div v-if="con.messageType == messageTypes.Audio">
              <ChatAudioPlayer
                :filePath="con.filePath"
                :userType="con.userType"
              />
            </div>
            <!-- messageType = 21 postback -->
            <div
              v-if="
                con.messageType != 1 &&
                  con.messageType != 4 &&
                  con.messageType != 21 &&
                  con.messageType != 16 &&
                  con.messageType != 22
              "
            >
              <ChatBoxWidget :con="con" />
            </div>

            <span class="msg_time text-nowrap">
              <ChatDateTime :date="con.createdTime" />
            </span>
          </div>
          <ChatBoxOptions
            :ref="`chatbox-option-${con.id}`"
            @reply="reply"
            @close="close"
          />
        </div>
      </div>
    </div>
    <ChatBoxModalImage ref="ChatBoxModalImage" :path="path" />
    <ModalTicketIframe ref="ModalTicketIframe" />
    <ChatBoxModalAlert ref="ChatBoxModalAlert" />
  </div>
</template>

<script>
import ChatDateTime from "@/components/chat/ChatDateTime";
import ChatBoxWidget from "@/components/chat/chatBox/ChatBoxWidget";
import ChatBoxModalImage from "@/components/chat/chatBox/modal/ChatBoxModalImage";
import ModalTicketIframe from "@/components/chat/chatOrder/chatOrderProfile/modal/ModalTicketIframe";
import ChatBoxReplyProfile from "@/components/chat/chatBox/reply/ChatBoxReplyProfile";
import ChatBoxOptions from "@/components/chat/chatBox/options/ChatBoxOptions";
import ChatAudioPlayer from "@/components/chat/ChatAudioPlayer";
import ChatBoxModalAlert from "@/components/chat/chatBox/modal/ChatBoxModalAlert";

import {
  SYSTEM_TYPES,
  SOCIAL_TYPES,
  MESSAGE_TYPES,
  SOCIAL_TYPES_NAME
} from "@/helpers/constants.js";

export default {
  name: "ChatBoxMessageList",
  components: {
    ChatDateTime,
    ChatBoxWidget,
    ChatBoxModalImage,
    ModalTicketIframe,
    ChatBoxReplyProfile,
    ChatBoxOptions,
    ChatAudioPlayer,
    ChatBoxModalAlert
  },
  props: {
    messageList: {
      required: true,
      type: Array
    },
    meProfile: {
      required: true,
      type: Object
    },
    otherInfo: {
      required: true,
      type: Object
    },
    msgSocialType: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      path: "",
      systemTypes: SYSTEM_TYPES,
      socialTypes: SOCIAL_TYPES,
      messageTypes: MESSAGE_TYPES,
      messageTypesName: SOCIAL_TYPES_NAME,
      selectOptionsMsg: null
    };
  },
  methods: {
    handleClickUnknownType(con) {
      if (con.custom?.payload) {
        this.$refs.ChatBoxModalAlert.show(JSON.parse(con.custom.payload));
      }
    },
    openModalImage(path) {
      this.path = path;
      this.$refs.ChatBoxModalImage.show();
    },
    showFormTicket(ticketUrl, isCreate = false) {
      let url = `${ticketUrl}?email=${this.$store.state.chatAdminProfile.email}`;
      this.$refs.ModalTicketIframe.show(url, isCreate);
    },
    handleRightClick(item) {
      const socialTypeId = this.msgSocialType?.socialTypeId;
      const providerReply = [this.socialTypes?.Line];

      if (providerReply.includes(socialTypeId)) {
        if (
          item.quoteToken &&
          ((item.userType == "admin" && item.isSendSuccess) ||
            item.userType == "user")
        ) {
          this.$refs[`chatbox-option-${item.id}`][0].show();
          this.selectOptionsMsg = item;
        }
      }
    },
    close() {
      this.$refs[`chatbox-option-${this.selectOptionsMsg.id}`][0].hide();
      this.selectOptionsMsg = null;
    },
    reply() {
      this.$emit("reply", this.selectOptionsMsg);
      this.$refs[`chatbox-option-${this.selectOptionsMsg.id}`][0].hide();
    },
    handleReSendMessage(item) {
      this.$emit("handleReSendMessage", item);
    },
    goToMsgId(item) {
      let msgId = item.id;
      setTimeout(async () => {
        try {
          let message = document.getElementById(`ref-msg-${msgId}`);
          await message.scrollIntoView({
            block: "center",
            behavior: "smooth"
          });
          await setTimeout(() => {
            message.classList.add("highlight_shake");
          }, 500);
          await setTimeout(() => {
            message.classList.remove("highlight_shake");
          }, 2000);
        } catch (error) {
          this.$emit("selectReplyMsg", item);
          console.log("goToMsg ref not found");
        }
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap_msg_cotainer_send {
  position: relative;
  max-width: 82%;
  // min-width: 25%;
  // width: 100%;
  transition: transform 0.3s;
  margin-left: 10px;
  .msg_cotainer_send {
    border-radius: 0px 0px 4px 4px !important;
  }
}
.wrap_msg_cotainer_send.highlight_shake,
.message_system_type.highlight_shake {
  animation: shake-left-right 0.75s ease;
}

@keyframes shake-left-right {
  0% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-4px);
  }
  40% {
    transform: translateX(4px);
  }
  60% {
    transform: translateX(-3px);
  }
  80% {
    transform: translateX(3px);
  }
  100% {
    transform: translateX(0);
  }
}
.user .reply_container.msg_cotainer_send {
  background-color: #b3fffd;
  margin-left: 10px;
  margin-right: 0px;
  max-width: 82%;
  min-width: 25%;
}
.user .reply_container.msg_cotainer_img {
  background-color: #b3fffd;
  // margin-left: 10px;
  margin-right: 0px;
  width: 100%;
}

.reply_container {
  border-bottom: 1px solid #e4e4e4;
  border-radius: 4px 4px 0px 0px !important;
  cursor: pointer;
}
.reply_container.msg_cotainer_img,
.reply_container.msg_cotainer_send_img {
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 10px;
  border-radius: 4px;
  background-color: #fbfbfb;
  color: #000;
  padding: 10px;
  position: relative;
  width: 100%;
  min-width: 25%;
  font-size: 14px;
  width: unset;
  justify-content: space-between;
  margin-left: 0;
  .wrap_img_upload {
    width: 35px !important;
    height: 35px !important;
    .img_upload {
      margin-right: 0;
      margin-left: auto;
      height: unset;
      max-height: unset;
      width: unset;
      max-width: unset;
      .img_upload-display {
        width: 35px !important;
        height: 35px !important;
        padding-bottom: unset;
        margin-left: 5px;
        background-position: center;
      }
    }
  }
}

.reply_container.msg_cotainer,
.reply_container.msg_cotainer_send {
  width: unset;
  .text-nextline {
    margin-left: 35px;
    color: #9c9c9c !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    max-height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    a {
      color: #9c9c9c !important;
    }
  }
}
.msg_cotainer_send_img {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  padding: 2px 10px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.msg_cotainer_send_img .wrap_img_upload {
  display: flex;
  width: 100%;
  flex-flow: column;
}
.msg_cotainer_send_img .wrap_img_upload .img_upload {
  margin-left: auto;
  height: auto;
  max-height: 20rem;
  width: 100%;
  max-width: 30rem;
}
.msg_cotainer_send_img .wrap_img_upload .img_upload .img_upload-display {
  width: 100%;
  padding-bottom: 56.25%;
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;
  background-color: inherit !important;
  cursor: pointer;
}

.msg_cotainer_send,
.msg_cotainer_send_private {
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 10px;
  border-radius: 4px;
  background-color: #fff;
  color: #000;
  padding: 10px;
  position: relative;
  font-size: 14px;

  max-width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.msg_cotainer_send_private {
  background-color: #fff1de !important;
}

.extent-width {
  width: 70% !important;
}
.spinner-grow {
  width: 20px;
  height: 20px;
}
.msg_wrap {
  white-space: pre-line;
  overflow-wrap: break-word;
}
.msg_time_send {
  margin-right: 15px;
  color: #bfbfbf;
  font-size: 10px;
}
.msg_cotainer_send_img .msg_time_send {
  padding-right: 10px;
}
.user_img_msg {
  height: 40px;
  width: 40px;
  border: 1.5px solid #f5f6fa;
}
.user_img_display {
  width: 100%;
  padding-bottom: 100.5%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
}
.img_display {
  width: 100px;
  height: auto;
  object-fit: contain;
  cursor: pointer;
  margin-right: 0.5rem;
}

.msg_cotainer_img {
  margin-top: auto;
  margin-bottom: auto;
  // margin-left: auto;
  padding: 2px 10px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: 80%;
}
.msg_cotainer_img .wrap_img_upload {
  display: flex;
  width: 100%;
  flex-flow: column;
}
.msg_cotainer_img .img_upload {
  margin-right: auto;
  height: auto;
  max-height: 20rem;
  width: 100%;
  max-width: 30rem;
}
.msg_cotainer_img .img_upload .img_upload-display {
  width: 100%;
  padding-bottom: 56.25%;
  background-size: contain;
  background-position: top left;
  background-repeat: no-repeat;
  background-color: inherit !important;
}

.msg_cotainer_img .img_upload {
  &:has(.sticker_upload-display) {
    max-height: 10rem;
    width: 100%;
    max-width: 15rem;
  }
}

.img_upload .multi-img {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 0.5rem;
}

.img_upload .multi-img .img_upload-display {
  width: 80px;
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

.img_cont_msg {
  height: 40px;
  width: 40px;
}
.msg_cotainer {
  margin-top: auto;
  margin-bottom: auto;
  // margin-left: 10px;
  border-radius: 4px;
  background-color: #b3fffd;
  padding: 10px;
  position: relative;
  // max-width: 82%;
  min-width: 25%;
  font-size: 14px;
}
.msg_time {
  position: absolute;
  left: 0;
  bottom: -15px;
  color: #bfbfbf;
  font-size: 10px;
}
.msg_cotainer_img .msg_time {
  padding-left: 10px;
}
.loading-dummy-img {
  position: absolute;
  width: 20%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}

.separator,
.separator-noline {
  text-align: center;
  color: #bfbfbf;
  font-size: 14px;
  .admin-name {
    color: #000000;
    font-weight: 600;
  }
  .click-for-detail {
    color: #000000;
    font-weight: 600;
    cursor: pointer;
  }
  .click-for-detail:hover {
    text-decoration: underline;
  }
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #cccccc;
}

.separator:not(:empty)::before {
  margin-right: 0.4em;
}

.separator:not(:empty)::after {
  margin-left: 0.4em;
}
.separator.ticket {
  cursor: pointer;
}
.separator.ticket:hover {
  text-decoration: underline;
}
.end-chat-time {
  text-align: center;
  color: #bfbfbf;
  font-size: 11px;
}
.icon-check {
  color: #009f00;
  margin-right: 0.25rem;
}
.text-black {
  color: #000 !important;
}
::v-deep .text-nextline {
  white-space: pre-line;
  a {
    color: #000;
    text-decoration: underline;
  }
}
::v-deep .reply_container .text-nextline {
  white-space: pre-line;
  a {
    color: #9c9c9c;
    text-decoration: none;
  }
}
.sending-chat {
  margin-top: 3px;
  width: 0.5rem;
  height: 0.5rem;
}
.send-fail {
  cursor: pointer;
  display: flex !important;
  flex-flow: row !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  padding-top: 4px;
  font-size: 10px;
  color: #f24726;
  svg {
    margin-left: 3px;
  }
}
.send-fail:hover {
  text-decoration: underline;
}

@media (max-width: 767.98px) {
}
</style>
